var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { AlertIDType } from '../../../const/alertsConfig';
import { onAttributeValueChange } from '../../../redux/alertsForm/actions';
import { getPurchaseExceedsErrorByKey, getPurchaseExceedsThresholdAmount } from '../../../redux/selectors';
import { AlertAttributeTypes } from '../../../typings/enums';
import AlertTextField from '../../atoms/AlertTextField';
import DeliveryMethodHelperText from '../../atoms/DeliveryMethodHelperText';
import { InputErrorWrapper } from '../../atoms/DeliveryMethodHelperText/subcomponents';
import { CustomRadio, CustomRadioGroup, PurchaseExceedsTextFieldWrapper } from './subcomponents';
var ApprovedTrnxRadio = function (_a) {
    var alertId = _a.alertId, inputKey = _a.inputKey, inputValue = _a.inputValue, inputError = _a.inputError, inputRef = _a.inputRef;
    var t = useTranslation().t;
    var dispatch = useDispatch();
    var purchaseExceedsValue = useSelector(getPurchaseExceedsThresholdAmount, shallowEqual);
    var purchaseExceedsError = useSelector(getPurchaseExceedsErrorByKey('purchaseExceedsThresholdAmount'), shallowEqual);
    var onChangeHandler = function (value) {
        dispatch(onAttributeValueChange(alertId, inputKey, value));
    };
    var transactionAuthLabel = t('approvedTransactionInfo.approvedTransactionLabel');
    var purchaseExeedsLabel = t('approvedTransactionInfo.purchaseExeedsLabel');
    var radioGroupLabel = t('approvedTransactionInfo.radioGroupLabel');
    var radioOptions = [
        {
            value: AlertIDType.TRANSACTION_AUTHORIZATION,
            label: transactionAuthLabel
        },
        {
            value: AlertIDType.PURCHASE_EXCEEDS,
            label: purchaseExeedsLabel
        }
    ];
    return (_jsxs(_Fragment, { children: [_jsx(CustomRadioGroup, __assign({ legend: radioGroupLabel, hideLegend: true, onChange: onChangeHandler, selected: inputValue }, { children: radioOptions.map(function (option, index) { return (_jsx(CustomRadio, __assign({ id: option.value, name: AlertIDType.APPROVED_TRANSACTIONS, value: option.value, radioRef: index === 0 ? inputRef : null, hasError: inputError && !inputValue }, { children: option.label }), option.value)); }) })), inputValue === AlertIDType.PURCHASE_EXCEEDS ? (_jsx(PurchaseExceedsTextFieldWrapper, { children: _jsx(AlertTextField, { alertId: AlertIDType.PURCHASE_EXCEEDS, inputKey: AlertAttributeTypes.PurchaseExceedsThresholdAmount, inputValue: purchaseExceedsValue, inputError: purchaseExceedsError, inputRef: inputRef }) })) : (''), _jsx(InputErrorWrapper, __assign({ "data-test": "InputErrorWrapper", hasError: !!inputError, "aria-hidden": "true" }, { children: inputError && !inputValue && (_jsx(DeliveryMethodHelperText, { "data-test": "DeliveryMethodHelperText", deliveryMethodError: inputError, alertId: alertId })) }))] }));
};
export default ApprovedTrnxRadio;
